import { IMAGE_SHAPE } from '../constants/products.constants';

const testImageURL = (
  'data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAA' +
  'AAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBA' +
  'QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQE' +
  'BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAIAAwMBEQACEQEDEQH/x' +
  'ABRAAEAAAAAAAAAAAAAAAAAAAAKEAEBAQADAQEAAAAAAAAAAAAGBQQDCAkCBwEBAAAAAAA' +
  'AAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AG8T9NfSMEVMhQ' +
  'voP3fFiRZ+MTHDifa/95OFSZU5OzRzxkyejv8ciEfhSceSXGjS8eSdLnZc2HDm4M3BxcXw' +
  'H/9k='
);


export function checkBrowserAutoRotate(): Promise<boolean> {
  // Check if the browser supports automatic image orientation:
  return new Promise<boolean>((res, rej) => {
    const testImage = new Image();
    testImage.onload = () => {
      res(testImage.width === 2 && testImage.height === 3);
    };

    testImage.onerror = (err) => {
      rej(err);
    };

    testImage.src = testImageURL;
  });
}

export function checkIfFileHeicFormat(file: File): boolean {
  return (/\.(heic|heif)$/i).test(file.name.toLowerCase());
}

export function getImageShape(image: { shape?: IMAGE_SHAPE; } | null | undefined): IMAGE_SHAPE {
  if (!image) {
    return IMAGE_SHAPE.HORIZONTAL;
  }

  if (image.shape) {
    return image.shape;
  }

  return IMAGE_SHAPE.HORIZONTAL;
}
